import React from 'react';
import PropTypes from 'prop-types';

KT01Content.propTypes = {

};

function KT01Content(props) {
    return (
        <div id='kt_content' className='d-flex flex-column'>
            {props.children}
        </div>
    );
}

export default KT01Content;